import React from 'react'
const ChangeContext = React.createContext({
    findMatchingSubscription: () => {},
    selectedData: {},
    selectedSubscription: {},
    availableSubscriptions: {},
    currentSubscription: {},
})
export default ChangeContext;